import endpoint from 'src/store/modules/endpoint'
import {
  soStatus,
  poStatus,
  doStatus
} from 'src/vars'

export const monitoringFlow = {
  api: endpoint.state.monitoringFlow,
  columns: [
    {
      name: 'soNo',
      field: row => {
        return row?.so_id
          ? `<a
              href="/so/detail/${row?.so_id}/${encodeURIComponent(row.so_no)}"
              class="goto-preview-page"
            >${row.so_no}</a>`
          : '-'
      },
      label: 'No. Sales Order',
      rowClass: 'text-no-wrap',
      columnFilter: {
        type: 'SEARCH',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-search.svg')
      },
      align: 'left'
    },
    {
      name: 'soStatus',
      field: row => {
        const val = row.so_status
        const status = soStatus.find(item => item.value === val)?.label
        if (val && status) {
          const badgeClass = val !== 'CANCELED' ? 'green' : 'red'
          return `
            <div role="alert" class="custom-badge-${badgeClass} dense">
              ${status}
            </div>
          `
        }

        return '-'
      },
      label: 'Status Sales Order',
      columnFilter: {
        type: 'CHECKBOX',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-chevron-down.svg')
      },
      align: 'left'
    },
    {
      name: 'paylater',
      field: row => {
        return row.paylater
          ? {
              JM: 'JM Paylater',
              PAPER: 'Paper.id',
              KOINWORKS: 'Koinworks',
              CREDILINQ: 'Credilinq.ai'
            }[row.paylater] || row.paylater
          : 'Tunai'
      },
      label: 'Pembayaran Customer',
      align: 'left',
      columnFilter: {
        type: 'CHECKBOX',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-chevron-down.svg')
      }
    },
    {
      name: 'customerName',
      field: row => {
        if (!row.customer_name) {
          return '-'
        }
        const customerType = row.company_id ? 'BUSINESS' : 'RETAIL'
        return `<a
              href="/customer/detail/preview/${row?.customer_id}/undefined/${customerType}"
              class="goto-preview-page"
            >
              ${row.customer_name}
            </a>`
      },
      label: 'Customer',
      align: 'left',
      rowClass: 'text-capitalize text-no-wrap',
      columnFilter: {
        type: 'SEARCH',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-search.svg')
      }
    },
    {
      name: 'referalCode',
      field: 'referal_code',
      label: 'Sales',
      align: 'left',
      rowClass: 'text-no-wrap',
      columnFilter: {
        type: 'CHECKBOX_SEARCH',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-chevron-down.svg')
      }
    },
    {
      name: 'destinationAddress',
      field: 'destination_address',
      label: 'Alamat Tujuan',
      rowClass: 'td-width-medium',
      align: 'left',
      columnFilter: {
        type: 'SEARCH',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-search.svg')
      }
    },
    {
      name: 'originAddress',
      field: 'origin_address',
      label: 'Alamat Asal',
      rowClass: 'td-width-medium',
      align: 'left',
      columnFilter: {
        type: 'SEARCH',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-search.svg')
      }
    },
    {
      name: 'poNo',
      field: row => {
        return row.po_no
          ? `<a
            href="/po/detail/${row?.po_id}/${encodeURIComponent(row.po_no)}"
            class="goto-preview-page"
          >${row.po_no}</a>`
          : '-'
      },
      label: 'No. Purchase Order',
      rowClass: 'text-no-wrap',
      columnFilter: {
        type: 'SEARCH',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-search.svg')
      },
      align: 'left'
    },
    {
      name: 'poStatus',
      field: row => {
        const val = row.po_status
        const status = poStatus.find(item => item.value === val)?.label
        if (val && status) {
          const badgeClass = val === 'CANCELED' ? 'red' : 'green'
          return `
            <div role="alert" class="custom-badge-${badgeClass} dense">
              ${status}
            </div>
          `
        }

        return '-'
      },
      label: 'Status Purchase Order',
      columnFilter: {
        type: 'CHECKBOX',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-chevron-down.svg')
      }
    },
    {
      name: 'poPaymentType',
      field: row => {
        return row.po_payment_type
          ? {
              TEMPO: `<div>Tempo</div>
                <small class="text-grey-6">${row.po_termin_day} Hari</small>
                `,
              CBD: 'CBD',
              COD: 'COD'
            }[row.po_payment_type]
          : '-'
      },
      label: 'Pembayaran Vendor',
      align: 'left',
      columnFilter: {
        type: 'CHECKBOX',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-chevron-down.svg')
      }
    },
    {
      name: 'doNo',
      field: row => {
        return row.do_no
          ? `<a
              href="/do/detail/${row?.do_id}/${encodeURIComponent(row.do_no)}"
              class="goto-preview-page"
            >${row.do_no}</a>`
          : '-'
      },
      label: 'No. Delivery Order',
      rowClass: 'text-no-wrap',
      columnFilter: {
        type: 'SEARCH',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-search.svg')
      },
      align: 'left'
    },
    {
      name: 'doStatus',
      field: row => {
        const val = row.do_status
        const status = doStatus.find(item => item.value === val)?.label
        if (val && status) {
          const badgeClass = val !== 'CANCELED' ? 'green' : 'red'
          return `
            <div role="alert" class="custom-badge-${badgeClass} dense">
              ${status}
            </div>
          `
        }

        return '-'
      },
      label: 'Status Delivery Order',
      columnFilter: {
        type: 'CHECKBOX',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-chevron-down.svg')
      }
    },
    {
      name: 'goodsHandoverStatus',
      field: 'goods_handover_status',
      label: 'Jenis Pengiriman',
      align: 'left',
      columnFilter: {
        type: 'CHECKBOX',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-chevron-down.svg')
      }
    },
    {
      name: 'productName',
      field: 'product_name',
      label: 'Nama Barang',
      rowClass: 'td-width-medium',
      align: 'left',
      columnFilter: {
        type: 'SEARCH',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-search.svg')
      }
    },
    {
      name: 'soCreatedAt',
      field: 'so_created_at',
      label: 'Tgl. Sales Order',
      commonDate: true,
      align: 'left',
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg')
      }
    },
    {
      name: 'poCreatedAt',
      field: 'po_created_at',
      label: 'Tgl. Purchase Order',
      commonDate: true,
      align: 'left',
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg')
      }
    },
    {
      name: 'poApproveAt',
      field: 'po_approve_at',
      label: 'Tgl. PO Disetujui',
      commonDate: true,
      align: 'left',
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg')
      }
    },
    {
      name: 'doCreatedAt',
      field: 'do_created_at',
      label: 'Tgl. Delivery Order',
      commonDate: true,
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg')
      },
      align: 'left'
    },
    {
      name: 'shippingAt',
      field: 'shipping_at',
      label: 'Est. DO Dikirim',
      commonDate: true,
      align: 'left',
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg')
      }
    },
    {
      name: 'doDeliveryAt',
      field: 'do_delivery_at',
      label: 'Tgl. DO Terkirim',
      commonDate: true,
      align: 'left',
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg')
      }
    },
    {
      name: 'doReturnLetterAt',
      field: 'do_return_letter_at',
      label: 'Tgl. SJ Balik',
      commonDate: true,
      align: 'left',
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg')
      }
    },
    {
      name: 'vendorPaidAt',
      field: 'vendor_paid_at',
      label: 'Tgl. Pembayaran Vendor',
      commonDate: true,
      align: 'left',
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg')
      }
    },
    {
      name: 'invCreatedAt',
      field: 'inv_created_at',
      label: 'Tgl. Invoice',
      commonDate: true,
      align: 'left',
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg')
      }
    },
    {
      name: 'invSendingAt',
      field: 'inv_sending_at',
      label: 'Tgl. Kirim Invoice',
      commonDate: true,
      align: 'left',
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg')
      }
    },
    {
      name: 'invConfirmedAt',
      field: 'inv_confirmed_at',
      label: 'Tgl. Invoice Dikonfirmasi',
      commonDate: true,
      align: 'left',
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg')
      }
    },
    {
      name: 'invExpiredAt',
      field: 'inv_expired_at',
      label: 'Tgl. Jatuh Tempo Invoice',
      commonDate: true,
      align: 'left',
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg')
      }
    },
    {
      name: 'invPaidAt',
      field: 'inv_paid_at',
      label: 'Tgl. Pembayaran Invoice',
      commonDate: true,
      align: 'left',
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg')
      }
    },
    {
      name: 'invVerifiedAt',
      field: 'inv_verified_at',
      label: 'Tgl. Verifikasi Invoice',
      commonDate: true,
      align: 'left',
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg')
      }
    }
  ]
}
